import type { Lesson } from "@prisma/client";
import MonthlyPieCharts from "./MonthlyPieCharts";

interface MonthlySummaryProps {
	lessonsOnDisplayMonth: Lesson[];
}

export default function MonthlySummary(props: MonthlySummaryProps) {
	const { lessonsOnDisplayMonth } = props;
	if (lessonsOnDisplayMonth.length === 0) {
		return (
			<div className="flex justify-center pt-6 text-2xl font-bold">
				今月の授業はありません
			</div>
		);
	}
	const {
		totalWage,
		totalWorkTime,
		totalLessonsPerGrades,
		totalTowPersonLessons,
		totalThreePersonLessons,
	} = calculateTotal(lessonsOnDisplayMonth);
	return (
		<div className="flex flex-col lg:flex-row">
			<div className="w-full flex-1 px-3 py-6 lg:w-1/2">
				<div className="mx-auto mt-3 grid max-w-96 grid-cols-[auto_auto] items-baseline gap-x-2 gap-y-1 rounded-md bg-white p-6 shadow-sm">
					<div className="font-medium">総賃金</div>
					<div className="text-2xl font-bold">
						<span>{totalWage.toLocaleString()}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							円
						</span>
					</div>
					<div className="font-medium">総授業時間</div>
					<div className="text-2xl font-bold">
						<span>{Math.floor(totalWorkTime / 60)}</span>
						<span className="mr-1 ml-1 text-xs font-medium lg:text-base">
							時間
						</span>
						<span>{totalWorkTime % 60}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							分
						</span>
					</div>
					<div className="font-medium">小学生</div>
					<div className="text-2xl font-bold">
						<span>{totalLessonsPerGrades[0]}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							コマ
						</span>
					</div>
					<div className="font-medium">中学生</div>
					<div className="text-2xl font-bold">
						<span>{totalLessonsPerGrades[1]}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							コマ
						</span>
					</div>
					<div className="font-medium">高校生</div>
					<div className="text-2xl font-bold">
						<span>{totalLessonsPerGrades[2]}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							コマ
						</span>
					</div>
					<div className="font-medium">2人授業数</div>
					<div className="text-2xl font-bold">
						<span>{totalTowPersonLessons}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							回
						</span>
					</div>
					<div className="font-medium">3人授業数</div>
					<div className="text-2xl font-bold">
						<span>{totalThreePersonLessons}</span>
						<span className="ml-1 text-xs font-medium lg:text-base">
							回
						</span>
					</div>
				</div>
			</div>
			<MonthlyPieCharts totalLessonsPerGrades={totalLessonsPerGrades} />
		</div>
	);
}

function calculateTotal(lessons: Lesson[]): {
	totalWage: number;
	totalWorkTime: number;
	totalLessonsPerGrades: string[];
	totalTowPersonLessons: number;
	totalThreePersonLessons: number;
} {
	let totalWage = 0;
	let totalWorkTime = 0;
	const totalLessonsPerGradesNum = [0, 0, 0];
	let totalTowPersonLessons = 0;
	let totalThreePersonLessons = 0;
	lessons.forEach((lesson) => {
		let flag = true;
		let sum = 0;
		for (let i = lesson.students.length - 1; i >= 0; i--) {
			if (lesson.students[i] > 0) {
				if (flag) {
					totalLessonsPerGradesNum[i] += lesson.minutes;
					flag = false;
				}
				sum += lesson.students[i];
			}
		}
		if (sum === 2) {
			totalTowPersonLessons += 1;
		} else if (sum === 3) {
			totalThreePersonLessons += 1;
		}
		totalWage += lesson.wage;
		totalWorkTime += lesson.minutes;
	});
	const totalLessonsPerGrades = totalLessonsPerGradesNum.map((time) => {
		if (time % 50 === 0) {
			return (time / 50).toFixed(0);
		} else {
			return (time / 50).toFixed(1);
		}
	});
	return {
		totalWage,
		totalWorkTime,
		totalLessonsPerGrades,
		totalTowPersonLessons,
		totalThreePersonLessons,
	};
}
